"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DOMException = require("domexception/webidl2js-wrapper");
var idlUtils = require("../generated/utils.js");
var attributes = require("../attributes.js");
var _require = require("../helpers/namespaces"),
  HTML_NS = _require.HTML_NS;
exports.implementation = /*#__PURE__*/function (_idlUtils$supportedPr, _idlUtils$supportedPr2) {
  function NamedNodeMapImpl(globalObject, args, privateData) {
    _classCallCheck(this, NamedNodeMapImpl);
    this._element = privateData.element;
    this._globalObject = globalObject;
  }
  _createClass(NamedNodeMapImpl, [{
    key: "_attributeList",
    get: function get() {
      return this._element._attributeList;
    }
  }, {
    key: _idlUtils$supportedPr,
    get: function get() {
      return this._attributeList.keys();
    }
  }, {
    key: "length",
    get: function get() {
      return this._attributeList.length;
    }
  }, {
    key: "item",
    value: function item(index) {
      if (index >= this._attributeList.length) {
        return null;
      }
      return this._attributeList[index];
    }
  }, {
    key: _idlUtils$supportedPr2,
    get: function get() {
      var names = new Set(this._attributeList.map(function (a) {
        return a._qualifiedName;
      }));
      var el = this._element;
      if (el._namespaceURI === HTML_NS && el._ownerDocument._parsingMode === "html") {
        var _iterator = _createForOfIteratorHelper(names),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var name = _step.value;
            var lowercaseName = name.toLowerCase();
            if (lowercaseName !== name) {
              names["delete"](name);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return names;
    }
  }, {
    key: "getNamedItem",
    value: function getNamedItem(qualifiedName) {
      return attributes.getAttributeByName(this._element, qualifiedName);
    }
  }, {
    key: "getNamedItemNS",
    value: function getNamedItemNS(namespace, localName) {
      return attributes.getAttributeByNameNS(this._element, namespace, localName);
    }
  }, {
    key: "setNamedItem",
    value: function setNamedItem(attr) {
      // eslint-disable-next-line no-restricted-properties
      return attributes.setAttribute(this._element, attr);
    }
  }, {
    key: "setNamedItemNS",
    value: function setNamedItemNS(attr) {
      // eslint-disable-next-line no-restricted-properties
      return attributes.setAttribute(this._element, attr);
    }
  }, {
    key: "removeNamedItem",
    value: function removeNamedItem(qualifiedName) {
      var attr = attributes.removeAttributeByName(this._element, qualifiedName);
      if (attr === null) {
        throw DOMException.create(this._globalObject, ["Tried to remove an attribute that was not present", "NotFoundError"]);
      }
      return attr;
    }
  }, {
    key: "removeNamedItemNS",
    value: function removeNamedItemNS(namespace, localName) {
      var attr = attributes.removeAttributeByNameNS(this._element, namespace, localName);
      if (attr === null) {
        throw DOMException.create(this._globalObject, ["Tried to remove an attribute that was not present", "NotFoundError"]);
      }
      return attr;
    }
  }]);
  return NamedNodeMapImpl;
}(idlUtils.supportedPropertyIndices, idlUtils.supportedPropertyNames);